import { CraftContext } from "./CraftContext"
import { useEffect, useState } from "react"
import { fetchAllCraftsService, fetchFeaturedCraftsService, fetchCategorizedCraftsService } from "../../global-services/crafts.service"

function CraftProvider({ children }) {
  const [crafts, setCrafts] = useState([])
  const [loadingCrafts, setLoadingCrafts] = useState(true)
  const [error, setError] = useState(null)
  const [refreshCrafts, setRefreshCrafts] = useState(false)
  const [loadingFeaturedCrafts,setLoadingFeaturedCrafts] = useState(true)
  const [featuredCrafts,setFeaturedCrafts] = useState([])
  const [errorFeaturedCrafts,setErrorFeaturedCrafts] = useState(null)
  const [categorizedCrafts, setCategorizedCrafts] = useState([])
  const [loadingCategorizedCrafts, setLoadingCategorizedCrafts] = useState(true)
  const [errorCategorizedCrafts, setErrorCategorizedCrafts] = useState(null)
  

  const [searchLoading, setSearchLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const searchAllCrafts = async (term) => {
    setSearchLoading(true);
    try {
      const data = await fetchAllCraftsService(term);
      setCrafts(data.crafts || []);
    } catch (err) {
      console.error("Error searching crafts:", err);
      setError(err.message);
    } finally {
      setSearchLoading(false);
    }
  };

  useEffect(() => {
    const fetchCrafts = async () => {
      setLoadingCrafts(true)
      try {
      
        const data = await fetchAllCraftsService()
        setCrafts(data.crafts || [])
      } catch (err) {
        setError(err.message)
        setCrafts([])
      } finally {
        setLoadingCrafts(false)
      }
    }

    const featuredCrafts = async ()=>{
      setLoadingFeaturedCrafts(true)
      try{
     const data = await fetchFeaturedCraftsService()
     console.log(data,'data')
     setFeaturedCrafts(data.data || [])
      }catch(err){
        setErrorFeaturedCrafts(err.message)
        setFeaturedCrafts([])
      }finally{
        setLoadingFeaturedCrafts(false)
      }
    }

    const categorizedCrafts = async () => {
      setLoadingCategorizedCrafts(true)
      try {
        const data = await fetchCategorizedCraftsService()
        setCategorizedCrafts(data.categories || [])
      } catch (err) {
        setErrorCategorizedCrafts(err.message)
        setCategorizedCrafts([])
      } finally {
        setLoadingCategorizedCrafts(false)
      }
    }

    fetchCrafts()
    featuredCrafts()
    categorizedCrafts()
  }, [refreshCrafts])

  return (
    <CraftContext.Provider
      value={{
        crafts,
        loadingCrafts,
        error,
        refreshCrafts,
        setRefreshCrafts,
        featuredCrafts,
        loadingFeaturedCrafts,
        errorFeaturedCrafts,
        categorizedCrafts,
        loadingCategorizedCrafts,
        errorCategorizedCrafts,
        searchAllCrafts,
        searchLoading,
        searchTerm,
        setSearchTerm
      }}
    >
      {children}
    </CraftContext.Provider>
  )
}

export default CraftProvider
